import GTM_ITEM_CATEGORIES from '../constants/gtmItemCategories';
import GTM_ITEM_XML_CATEGORIES from '../constants/gtmItemXmlCategories';
import getRoundedPrice from './getRoundedPrice';

const convertDishToGtmItem = ({
  brandName,
  basketDiscountCode,
  dish: { dishSize, day, price, quantity },
  totalQuantityInBasketRow,
}) => ({
  // eslint-disable-next-line camelcase -- FIXME
  item_id: `${dishSize.id}`,
  // eslint-disable-next-line camelcase -- FIXME
  item_xml_id: `${GTM_ITEM_XML_CATEGORIES.dish}_${dishSize.id}`,
  // eslint-disable-next-line camelcase -- FIXME
  item_name: dishSize.name,
  coupon: basketDiscountCode,
  discount: price.discount,
  index: 0,
  // eslint-disable-next-line camelcase -- FIXME
  item_brand: brandName,
  // eslint-disable-next-line camelcase -- FIXME
  item_category: GTM_ITEM_CATEGORIES.dish,
  // eslint-disable-next-line camelcase -- FIXME
  item_category2: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category3: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category4: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category5: dishSize.size.name,
  // eslint-disable-next-line camelcase -- FIXME
  item_category6: false,
  // eslint-disable-next-line camelcase -- FIXME
  item_category7: 0,
  // eslint-disable-next-line camelcase -- FIXME
  item_category8: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category9: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category10: day,
  // eslint-disable-next-line camelcase -- FIXME
  item_category11: day,
  // eslint-disable-next-line camelcase -- FIXME
  item_category12: '',
  price: getRoundedPrice(price.afterDiscount / totalQuantityInBasketRow),
  quantity: Math.abs(quantity),
  duration: 1,
});

export default convertDishToGtmItem;
